export enum SpeakingSlotAction {
  AddSlot = 0,
  AddBreak = 1,
  Clear = 2,
}
